import {Collection} from 'MWC';
import Model from '../models/main.m';

export default class extends Collection {
    static model = Model;
}
